import classNames from 'classnames';
import { MouseEvent } from 'react';
import type { ColorsTheme } from '@alltrails/types/ColorsTheme';
import ArrowSq from '../../icons/ArrowSq';
import IconButton from '../IconButton';
import styles from './Carousel.module.scss';

type ArrowButtonProps = { className?: string; onClick: () => void; theme?: ColorsTheme; title: string };

const ArrowButton = (orientation: 'left' | 'right') =>
  function ({ className, onClick, theme, title }: ArrowButtonProps) {
    return (
      <IconButton
        className={classNames(styles[`${orientation}Arrow`], className)}
        icon={{ Component: ArrowSq, orientation }}
        onClick={(e?: MouseEvent) => {
          e?.preventDefault();
          e?.stopPropagation();
          onClick();
        }}
        theme={theme}
        title={title}
        size="md"
        variant="ghost"
        elevated
      />
    );
  };

export const LeftArrow = ArrowButton('left');
export const RightArrow = ArrowButton('right');
